/* eslint-disable tailwindcss/no-arbitrary-value */
import { useEffect, useState } from 'react';
import AddCheck from '$/components/icons/AddCheck';
import Like from '$/components/icons/Like';

type SupportedPaymentProps = {
  label?: string;
  values?: string[];
  staticText: {
    dialogSeeMore: string;
    dialogSeeLess: string;
  };
};

export default function SupportedPayment({
  label,
  values = [],
  staticText,
}: SupportedPaymentProps): JSX.Element | null {
  const [isExpanded, setIsExpanded] = useState(false);
  const [maxVisible, setMaxVisible] = useState(3);

  useEffect(() => {
    const updateMaxVisible = () => {
      if (window.innerWidth > 1280) {
        setMaxVisible(values.length);
      } else {
        setMaxVisible(3);
      }
    };

    updateMaxVisible();

    const resizeListener = () => updateMaxVisible();
    window.addEventListener('resize', resizeListener);
    return () => {
      window.removeEventListener('resize', updateMaxVisible);
    };
  }, [values.length]);

  if (!values || values.length === 0) {
    return null;
  }

  const visibleValues = isExpanded ? values : values.slice(0, maxVisible);
  const hiddenCount =
    values.length > maxVisible ? values.length - visibleValues.length : 0;

  return (
    <div className="flex flex-col items-start gap-[--spacing-gap-y-sm] self-stretch pt-[--spacing-gap-y-sm]">
      <div className="flex items-center justify-center gap-[10px] px-[--spacing-padding-y] py-0">
        <Like className="size-6" />
        <span className="mhg-alpha-subheading-2 text-center text-[--text-accent]">
          {label}
        </span>
      </div>
      <div className="mhg-alpha-box-shadow-1 flex flex-col items-start self-stretch rounded-b-[--radius-card] rounded-t-none border-r border-solid border-r-[--borders-default] bg-[--fill-card]">
        <div
          className={`flex items-start self-stretch border-t-2 border-solid border-t-[--fill-primary] pb-[--spacing-padding-y-xs] ${values?.length > maxVisible ? 'lg:pb-0' : 'lg:pb-4'}`}
        >
          <div className="flex flex-[1_0_0] flex-col items-start gap-[--spacing-gap-y-sm] px-[--spacing-padding-x-sm] pb-0 pt-[--spacing-padding-y] lg:px-[--spacing-padding-x]">
            {visibleValues?.map((value) => (
              <div
                className="flex items-start gap-[--spacing-gap-x-xs] self-stretch"
                key={value}
              >
                <div className="mt-[2px] flex">
                  <AddCheck className="size-[--shapes-icon-size-md] text-[--shapes-icon-size-md]" />
                </div>
                <div className="mhg-alpha-body-2-relaxed text-[--text-primary]">
                  {value}
                </div>
              </div>
            ))}
          </div>
        </div>
        {values?.length > maxVisible && (
          <button
            type="button"
            className="mhg-alpha-button-2 mhg-alpha-spacing-padding-y-spacing-padding-x flex w-full flex-col items-start justify-center font-[--font-weight-button-1] text-[--text-link]"
            onClick={() => setIsExpanded(!isExpanded)}
          >
            {isExpanded
              ? staticText.dialogSeeLess
              : `${staticText.dialogSeeMore} (${hiddenCount})`}
          </button>
        )}
      </div>
    </div>
  );
}
